class StepsController {
  constructor() {
    this.name = 'steps';
  }

  $onInit(){
    this.step = this.steps && this.steps.length > 0 ? this.steps[0] : null;
    // console.log(this);
  }

  setStep(index){
     if(index >= 0) {
       this.step = (this.steps.length - 1 > index) ? this.steps[index] : this.steps[this.steps.length - 1];
       this.page = this.step.page;
     }
  }

  getCurrentProgress(){
    let ind = this.steps.findIndex(x => x.page === this.step.page);
    let result = ind > -1 ? (ind+1)/this.steps.length : 0;
    return Math.round(result*100);
  }

}

export default StepsController;



// WEBPACK FOOTER //
// ./client/app/components/steps/steps.controller.js